export default {
  preview: "_fmst_preview",
  draft: "_fmst_continue",
  collaborate: "_fmst_collaborate",
  edit: "_fmst_edit",
};
